// @ constants
const actionTypes = require('constants/actionTypes');

// @ commons
const { APIPost } = require('utilities/APIRequestHelper');
const { getLastNChars } = require('utilities/stringHelper');

// @ actions
const signaturePatternActions = require('actions/signaturePattern');
const { outdateGlobalPosition } = require('actions/myGlobalPosition');
const { baseRequestData, confirmationFailure, confirmationSuccess, confirmationRequest } = require('actions/cardCharge');

const getOYAccountsRequest = () => ({
  type: actionTypes.OPENYOUNG_CARD_ACCOUNTS_REQUEST
});

const getOYAccountsRequestSuccess = (oyAccountsList) => ({
  type: actionTypes.OPENYOUNG_CARD_ACCOUNTS_REQUEST_SUCCESS,
  payload: {
    oyAccountsList
  }
});

const getOYAccountsRequestError = (error) => ({
  type: actionTypes.OPENYOUNG_CARD_ACCOUNTS_REQUEST_ERROR,
  payload: {
    error
  }
});

const getOYAccountsList = (immCard) => (dispatch, getState) => {
  dispatch(getOYAccountsRequest());
  const last4DigitPanCard = getLastNChars(immCard.get('number'), 4, '');
  const params = {
    header: {
        version: '2',
    },
    query: {
      'last4DigitOfPan' : last4DigitPanCard
    }
  };

  return APIPost({
    dispatch,
    endpoint: 'openYoungAccounts',
    params
  })
    .then((responseSuccess) => {
      const oyAccountsList = responseSuccess.map((item) => {
        return item.newAccount;
      });
      let openYoungAccounts = getState().accounts.get('byOrder');
      openYoungAccounts = openYoungAccounts.filter(accountId => {
          const immAccount = getState().accounts.getIn(['byId', accountId]);
          const oyAccount = oyAccountsList.filter((account) => {
              return (account.producto === immAccount.get('newProduct'))
                          && (account.numerodecontrato === immAccount.get('newContractNumber'));
          });
          if(oyAccount.length !== 0) {
              return accountId;
          }
      });
      dispatch(getOYAccountsRequestSuccess(openYoungAccounts));
    })
    .catch(response => {
      if (!!response.error) {
        dispatch(getOYAccountsRequestError(response));
      } else {
        throw response;
      }
    });
};

const moneyRequestConfirmationRequest = () => ({
  type: actionTypes.OPENYOUNG_CARD_MONEY_SAVINGS_REJECT_REQUEST
});

const moneyRequestConfirmationSuccess = () => ({
  type: actionTypes.OPENYOUNG_CARD_GET_SAVINGS_REQUEST_CONFIRMATION_SUCCESS
});

const moneySavingsDetailsRequest = () => ({
  type: actionTypes.OPENYOUNG_CARD_MONEY_SAVINGS_DETAILS_REQUEST
});

const moneySavingsDetailsRequestError = (error) => ({
  type: actionTypes.OPENYOUNG_CARD_MONEY_SAVINGS_DETAILS_REQUEST_ERROR,
  payload: {
    error
  }
});

const moneySavingsDetailsRequestSuccess = (moneySavingsDetail) => ({
  type: actionTypes.OPENYOUNG_CARD_MONEY_SAVINGS_DETAILS_REQUEST_SUCCESS,
  payload: {
    moneySavingsDetail
  }
});

const rejectMoneyRequest = () => ({
  type: actionTypes.OPENYOUNG_CARD_MONEY_SAVINGS_REJECT_REQUEST
});

const moneySavingsRequestConfirmation = (cardId, requestStatus) => (dispatch, getState) => {
  const immCard = getState().cards.getIn(['byId', cardId]);
  const savingsDetail = getState().openYoungCardSavings.get('savingsDetail');
  const panNumber = getLastNChars(immCard.get('number'), 4, '');
  const actualAmount = getState().cardCharge.getIn(['steps', 0, 'amount']);
  const parentComment = savingsDetail.getIn(['parentComment']);
  const requestId = savingsDetail.getIn(['requestId']);

  let requestData = {
    query: {
      childDetail: {
        contractNumber: immCard.getIn(['contract', 'number']),
        pan: panNumber,
        productCode: immCard.getIn(['contract', 'product'])
      },
      requestMoney: {
        actualAmount,
        parentComment,
        requestId,
        requestStatus
      }
    }
  };

  dispatch(moneyRequestConfirmationRequest());
  return APIPost({
    dispatch,
    endpoint: 'openYoungMoneyRequestConfirmation',
    params: requestData
  })
    .then(responseSuccess => dispatch(moneyRequestConfirmationSuccess(responseSuccess)))
    .catch(response => {
      if (!!response.error) {
        dispatch(moneyRequestConfirmationSuccess(response));
      } else {
        throw response;
      }
    });
  /*  Pragati: SUCCESS has been called on purpose here even if the call fails because, the actual CARGA API will always be successful before this API call
      and only the notification has failed. So, we show success if only NOTIFICATION API failed. Confirmed with API team and PO */
}

const postChange = (cardId, requestStatus) => (dispatch, getState) => {
  const callback = (dispatch, getState, dataToken) => {
    const immCardCharge = getState().cardCharge;
    const immCardChargeStep1 = immCardCharge.getIn(['steps', 0]);

    const accountId = immCardChargeStep1.get('accountId');
    const cardId = immCardChargeStep1.get('cardId');

    const liquidationData = immCardCharge.getIn(['extra', 'liquidationData']).toJS();
    const confirmationEndpoint = 'eCardDischargeConfirmation';

    const requestData = baseRequestData(getState, cardId, accountId);
    requestData.query.dataToken = dataToken;
    requestData.query.datosPreliq = liquidationData;
    requestData.query.importeOperacion.importe = immCardChargeStep1.get('amount');
    dispatch(confirmationRequest());

    return APIPost({
      dispatch,
      endpoint: confirmationEndpoint,
      params: requestData
    })
      .then((response) => {
        dispatch(outdateGlobalPosition());
        dispatch(confirmationSuccess(response));
        return dispatch(moneySavingsRequestConfirmation(cardId, requestStatus));
      })
      .catch(response => {
        if (!!response.error) {
          dispatch(confirmationFailure(response.error));
        } else {
          throw response;
        }
      });
  };
  new Promise(function () {
    signaturePatternActions.validateAndExecute(dispatch, getState, callback);
  })
}

const moneySavingsRequestDetails = (referenceId, data = {}) => (dispatch) => {
  dispatch(moneySavingsDetailsRequest());

  const requestData = {
    query: {
      requestId: referenceId
    }
  };

  return APIPost({
    dispatch,
    endpoint: 'openYoungMoneyRequestDetails',
    params: requestData
  })
    .then(response => {
      dispatch(moneySavingsDetailsRequestSuccess(response));
      data.successCallback && data.successCallback(data.path, response);
    })
    .catch(response => {
      if (!!response.error) {
        dispatch(moneySavingsDetailsRequestError(response.error.description));
        data.errorCallback && data.errorCallback();
      } else {
        throw response;
      }
    });
}

const rejectMoneyRequestCall = (cardId, requestStatus) => (dispatch) => {
  dispatch(rejectMoneyRequest());
  dispatch(moneySavingsRequestConfirmation(cardId, requestStatus));
}

module.exports = {
  getOYAccountsList,
  moneySavingsRequestDetails,
  moneySavingsRequestConfirmation,
  postChange,
  rejectMoneyRequestCall
}
